export const QUERY_ACTIONS = {
    SAVE: 'save',
    EDIT: 'edit',
    RENAME: 'rename',
};

export const CHART_TYPE = {
    CFD: 'cfd',
    LTD: 'ltd',
};
